import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { ContactTag } from "@/hooks/useContacts";

interface ContactTagFilterProps {
  tags: ContactTag[];
  selected: string[];
  onChange: (tags: string[]) => void;
}

export function ContactTagFilter({ tags, selected, onChange }: ContactTagFilterProps) {
  const toggle = (slug: string) => {
    if (selected.includes(slug)) {
      onChange(selected.filter((s) => s !== slug));
    } else {
      onChange([...selected, slug]);
    }
  };

  if (tags.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {tags.map((tag) => {
        const isSelected = selected.includes(tag.tag);
        return (
          <Button
            key={tag.id}
            variant="outline"
            size="sm"
            onClick={() => toggle(tag.tag)}
            className={cn(
              "h-7 rounded-full text-xs font-medium transition-colors",
              isSelected && "border-transparent text-white"
            )}
            style={
              isSelected && tag.color
                ? { backgroundColor: tag.color, borderColor: tag.color }
                : undefined
            }
          >
            {tag.label}
          </Button>
        );
      })}
      {selected.length > 0 && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onChange([])}
          className="h-7 text-xs text-muted-foreground"
        >
          Clear
        </Button>
      )}
    </div>
  );
}
